<script lang="ts">
  import CardView from '../components/cards/CardView.svelte';
  import type { CardAnswer } from '../components/cards/answer';
  import type { GradeResult } from '../components/types';
  import type { Card, UseCasesFile } from '../lib/cards';
  import { withResolvedUseCase } from './drill/display-card';
  import { isLocallyGraded, traceLocalGrade } from './drill/grade-telemetry';
  import { afterPaint } from './drill/paint';

  /**
   * カード単体 `#/card/:cardId`（キュー外の練習。layout-and-navigation.md §1）。
   * 回答は Leitner に記録しない。採点の計測（class.card.grade）は行う。
   */
  interface Props {
    card: Card;
    useCases: UseCasesFile | null;
    onnavigate: (hash: string) => void;
  }

  let { card, useCases, onnavigate }: Props = $props();

  const shown = $derived(withResolvedUseCase(card, useCases));
  let graded = $state<{ id: string; result: GradeResult; answer: CardAnswer } | null>(null);
  const current = $derived(graded?.id === card.id ? graded : null);

  function ongrade(result: GradeResult, answer: CardAnswer) {
    const target = card;
    const apply = () => {
      graded = { id: target.id, result, answer };
    };
    if (isLocallyGraded(target, answer))
      void traceLocalGrade(target, result.verdict, apply, afterPaint);
    else apply();
  }
</script>

<div class="page page-drill">
  {#key card.id}
    <CardView
      globalKeys
      card={shown}
      index={1}
      total={1}
      result={current?.result}
      answer={current?.answer}
      showUseCase={card.type !== 'reduce' || current !== null}
      {ongrade}
      onnext={() => onnavigate('#/')}
      onabort={() => onnavigate('#/')}
    />
  {/key}
</div>
